<template>
  <ui-select
    @change="viewChanged"
    class="view-picker"
    :value="value"
    :items="data"
    item-text="text"
    item-value="value"
    :prepend-inner-icon="icon"
    :autocomplete="false"
    :hide-details="1"
  ></ui-select>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import query from '@/components/query/query-constructor';
import { useI18n } from '@/composables/useI18n';
import { useTableQuery } from '@/composables/useTableQuery';
import { usePickerPushUrl } from '@/composables/usePickerPushUrl';
import { $emitter } from '@/services/emitter';

const { t } = useI18n();
const route = useRoute();
const tableQueryApi = useTableQuery();
const { pushReportUrl } = usePickerPushUrl();

const data = [
  { value: 'table', text: t('Table') },
  { value: 'tree', text: t('Treeview') },
];

const value = computed(
  () => (tableQueryApi.tableQueryTemporaryForCurrentTab.value.view as string) || 'tree',
);

const icon = computed(() =>
  value.value === 'table' ? 'fas fa-table' : 'fas fa-indent',
);

const applyDataFromUrl = () => {
  const { view } = query.decode(route.params.data as string);
  if (view === 'table' || view === 'tree') {
    tableQueryApi.setTableViewTemporary(view);
    tableQueryApi.setTableView(view);
  }
};

const onBusApplyFilters = () => {
  tableQueryApi.setTableView((tableQueryApi.tableQueryTemporaryForCurrentTab.value.view as string) || 'tree');
  pushReportUrl();
};

const onBusReportTabAdded = () => {
  applyDataFromUrl();
};

const viewChanged = (selectedView: string) => {
  tableQueryApi.setTableViewTemporary(selectedView);
};

const onBusReportTabUpdated = () => {};

onMounted(() => {
  $emitter.on('apply-filters', onBusApplyFilters);
  $emitter.on('report-tab-added', onBusReportTabAdded);
  $emitter.on('report-tab-updated', onBusReportTabUpdated);
  applyDataFromUrl();
});

onBeforeUnmount(() => {
  $emitter.off('apply-filters', onBusApplyFilters);
  $emitter.off('report-tab-added', onBusReportTabAdded);
  $emitter.off('report-tab-updated', onBusReportTabUpdated);
});
</script>

<style lang="scss">
  .view-picker {
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
  }
</style>
